import React, { Component } from "react";
import { Row, Col, Button } from "reactstrap";
import { getServerEndpoint } from "utils/serverEndpoint";
import SvgIcon from "react-icons-kit";
import { plus } from "react-icons-kit/icomoon/plus";
import "./uploadbutton.css";
import noImage from "images/noImage.png";
import { fetchStaticResource, sanitizedFilename } from "../../../utils/utils";
import { languageService } from "../../../Language/language.service";
class AssetImageArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainImageIndex: 0,
    };
  }

  render() {
    let imagesList = null;
    // console.log(this.props.imagesList)
    if (this.props.imagesList) {
      imagesList = this.props.imagesList.map((imageName, index) => {
        if (index > 0) {
          return (
            <div style={{ display: "inline-block", width: "30%", margin: "0 3% 0 0", cursor: "pointer" }} key={imageName + index}>
              <ImageMainComp imageName={imageName} borderStyle={"1px solid var(--first)"} width={"100%"} />
            </div>
          );
        }
      });
    }

    return (
      <div>
        <Row>
          <Col md={12}>
            <ImageMainComp imageName={this.props.imagesList[this.state.mainImageIndex]} />
          </Col>
        </Row>
        <Row>
          <Col md={10}>
            <div className="scrollbarHor" style={{ overflow: "auto", whiteSpace: "nowrap", padding: "10px 0px 5px 0px" }}>
              {imagesList}
            </div>
          </Col>
          <Col md={2} style={{ padding: "0px" }}>
            <div style={{ padding: "25px 0px", margin: "auto", width: "50%", color: "var(--first)" }}>
              {/* <div className="upload-btn-wrapper">
                <SvgIcon icon={plus} size={20} />

                <input type="file" name="myfile" accept="image/*" onChange={this.props.addImage} />
              </div> */}
              <SvgIcon icon={plus} size={20} onClick={this.props.showImageGallery} />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default AssetImageArea;

class ImageMainComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSrc: noImage, // Default to placeholder image
    };
  }

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.imageName !== this.props.imageName) {
      this.loadImage();
    }
  }

  async loadImage() {
    if (!this.props.imageName) {
      this.setState({ imageSrc: noImage });
      return;
    }
    const currentImageName = this.props.imageName; // Capture current prop
    try {
      const path = getServerEndpoint() + "assetImages/" + sanitizedFilename(this.props.imageName);
      const imageToDisplay = await fetchStaticResource(path);
       // Only update state if the prop hasn't changed since the fetch started
       if (currentImageName === this.props.imageName) {
        this.setState({ imageSrc: imageToDisplay });
      }
    } catch (error) {
      console.error("Error loading image:", error);
      this.setState({ imageSrc: noImage });
    }
  }

  render() {
    return (
      <div style={{ width: this.props.width || "inherit" }}>
        <img
          style={{
            width: "inherit",
            border: this.props.borderStyle || "3px solid var(--first)",
            borderRadius: "5px",
          }}
          src={this.state.imageSrc}
          alt={languageService("Image not found!")}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Line/Add/AssetImageArea.jsx